import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/arrowDiagonalLeft.tsx
var ArrowDiagonalLeft = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M4.57539 10.2323L4.57538 5.57547C4.57538 5.02319 5.02309 4.57547 5.57538 4.57547L10.2322 4.57546M13.7678 19.4247L18.4246 19.4247C18.9769 19.4247 19.4246 18.977 19.4246 18.4247L19.4246 13.7678M18.7175 18.7176L5.28247 5.28259",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M4.57539 10.2323L4.57538 5.57547C4.57538 5.02319 5.02309 4.57547 5.57538 4.57547L10.2322 4.57546M13.7678 19.4247L18.4246 19.4247C18.9769 19.4247 19.4246 18.977 19.4246 18.4247L19.4246 13.7678M18.7175 18.7176L5.28247 5.28259",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
//#endregion
export { ArrowDiagonalLeft };
